import { useMutation } from "@tanstack/react-query";
import { sendAuthUserInvite } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export function useAuthUserInvite() {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  return useMutation({
    mutationFn: async (payload) => sendAuthUserInvite(id, payload),
  });
}
